var _rect, _rect2, _text, _text2, _rect3, _rect4, _path, _text3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImg404(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 420,
    height: 300,
    viewBox: "0 0 420 300",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    "aria-label": "Image Not Found",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 420,
    height: 300,
    rx: 22,
    fill: "#f3f4f6"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 20,
    width: 380,
    height: 260,
    rx: 18,
    fill: "#ffffff"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 210,
    y: 95,
    textAnchor: "middle",
    fontSize: 48,
    fontWeight: 700,
    fill: "#ff8c00",
    fontFamily: "Arial, Helvetica, sans-serif"
  }, "\n        404\n    ")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 210,
    y: 130,
    textAnchor: "middle",
    fontSize: 14,
    fill: "#6b7280",
    fontFamily: "Arial, Helvetica, sans-serif"
  }, "\n        Image Not Available\n    ")), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 150,
    y: 160,
    width: 120,
    height: 44,
    rx: 10,
    fill: "#1E73BE"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 158,
    y: 168,
    width: 104,
    height: 28,
    rx: 6,
    fill: "#FFFFFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M164 182        H178        L190 192        L214 172        L226 182        H254",
    fill: "none",
    stroke: "#FF5A00",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 210,
    y: 240,
    textAnchor: "middle",
    fontSize: 12,
    fill: "#9ca3af",
    fontFamily: "Arial, Helvetica, sans-serif"
  }, "\n        Raja Alam Raya\n    ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImg404);
export default __webpack_public_path__ + "static/media/img_404.3010b8d786ac95a5b1046a7927bd9c5b.svg";
export { ForwardRef as ReactComponent };